import React, { Component, createRef } from "react";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class FillerUpdatePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    
    document.title = "filler flow";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem ={this.props.t("Update Password")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div>
                      <h4 className="text-black fw-bold mb-4">{this.props.t("Change Password")}</h4>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        oldPassword: (this.state && this.state.password) || "",
                        newPassword: (this.state && this.state.password) || "",
                        confirmPassword:
                          (this.state && this.state.confirmPassword) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        oldPassword: Yup.string()
                          .required("Please Enter your Old password"),
                        newPassword: Yup.string()
                          .required("Password is required")
                          .min(5, "Your password is too short.")
                          .matches(
                            "(?=.*[!@#$%^&*])",
                            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                          ),
                        confirmPassword: Yup.string()
                          .required()
                          .oneOf(
                            [Yup.ref("newPassword"), null],
                            "Passwords must match"
                          ),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="oldPassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Old Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.oldPassword && touched.oldPassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="password"
                                  name="oldPassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="oldPassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="newPassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("New Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.newPassword && touched.newPassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="password"
                                  name="newPassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="newPassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="confirmPassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Confirm Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.confirmPassword &&
                                    touched.confirmPassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="password"
                                  name="confirmPassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="confirmPassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                              >
                                Save Password
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(FillerUpdatePassword);

